// extracted by mini-css-extract-plugin
module.exports = {"container":"MasonryGrid_container__GVKWz","column":"MasonryGrid_column__30yU5"};